import type { PropsWithChildren } from 'react';

import type { MantineStyleProps } from '@mantine/core';
import { Center, Loader } from '@mantine/core';
import { Suspense } from 'react';

type SuspenseLoaderProps = {
	minHeight?: MantineStyleProps['mih'];
} & PropsWithChildren;

export function SuspenseLoader({ children, minHeight = '300px' }: SuspenseLoaderProps) {
	return (
		<Suspense
			fallback={
				<Center mih={minHeight}>
					<Loader />
				</Center>
			}
		>
			{children}
		</Suspense>
	);
}

export default SuspenseLoader;
